import { render, staticRenderFns } from "./MenuItemItem.vue?vue&type=template&id=4dce0529"
import script from "./MenuItemItem.vue?vue&type=script&lang=js"
export * from "./MenuItemItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports